module.exports = __webpack_public_path__ + "static/img/2.9b5a9816.png";